<!-- Send Bulk SMS Modal -->
<p-dialog [visible]="showPopup()" (onHide)="closePopupUp()" [closeOnEscape]="false" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'991px': '100vw'}" [style]="{width: '870px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="p-3 sticky top-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
      @if (smsSendType()  === GetSMSSendType.Bulk) {
        <h2 class="mb-0 text-sm">{{'SEND_SMS.SEND_BULK_SMS' | translate }}</h2>
      }
      @if (smsSendType() === GetSMSSendType.FreeForm) {
        <h2 class="mb-0 text-sm" [innerHTML]="'SEND_SMS.SEND_FREE_FORM_SMS' | translate : { name: this.SelectedClient().value.full_name } "></h2>
      }
      @if (smsSendType() === GetSMSSendType.Campaign) {
        <h2 class="mb-0 text-sm" >{{'SEND_SMS.SMS_CONFIG' | translate }}</h2>
      }
      @if (smsSendType() === GetSMSSendType.Automation) {
        <h2 class="mb-0 text-sm" >{{'SEND_SMS.SMS_CONFIG' | translate }}</h2>
      }
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopupUp()"></div>
    </div>
    <!-- Header -->

    <form [formGroup]="sendSmsForm">
      <!-- Show skeleton when loading -->
      @if (loading) {
        <div class="p-3 surface-100">
          <!-- Automation Schedule Type Skeleton -->
          <div class="mb-3">
            <p-skeleton width="100%" height="120px" />
          </div>
          <div class="surface-0 shadow-3 border-round relative text-sm">
            <!-- Campaign Toggle Skeleton -->
            <div class="flex align-items-center mb-2">
              <p-skeleton width="120px" height="24px" styleClass="mr-2" />
              <p-skeleton width="40px" height="24px" />
            </div>
            <div class="surface-0 shadow-3 p-3 border-round text-sm">
              <div class="py-1">
                <!-- From Dropdown Skeleton -->
                <div class="pl-6 relative mb-2">
                  <p-skeleton width="40px" height="16px" styleClass="absolute left-0 top-0 mt-2" />
                  <p-skeleton width="100%" height="35px" />
                </div>
                <!-- To Section Skeleton -->
                <div class="pl-6 relative mb-2">
                  <p-skeleton width="30px" height="16px" styleClass="absolute left-0 top-0 mt-2" />
                  <div class="flex flex-wrap align-items-center -ml-2">
                    <p-skeleton width="200px" height="35px" styleClass="m-2" />
                    <p-skeleton width="200px" height="35px" styleClass="m-2" />
                    <p-skeleton width="200px" height="35px" styleClass="m-2" />
                    <p-skeleton width="150px" height="24px" styleClass="ml-3 mt-2" />
                  </div>
                </div>
                <!-- Message Area Skeleton -->
                <div class="w-full relative">
                  <p-skeleton width="100%" height="112px" />
                </div>
              </div>
              <!-- Template Dropdown Skeleton -->
              <div class="surface-200 mt-2 text-center md:text-left py-1 md:px-3 px-0 md:flex align-items-center">
                <p-skeleton width="200px" height="35px" />
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Footer Skeleton -->
      @if (loading) {
        <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
          <p-skeleton width="100px" height="35px" />
          <p-skeleton width="120px" height="35px" />
        </div>
      }

      <!-- Show actual content when not loading -->
      @if (!loading) {
        <div>
          @if (smsSendType() === GetSMSSendType.Automation && showScheduleType.value) {
            <automation-schedule-type [formGroup]="sendSmsForm" [automationMaster]="automationMaster()" [type]="'SMS'" />
          }
          <!-- Content -->
          <div class="p-3 surface-100">
            @if (showCampaign.value && smsSendType() === GetSMSSendType.Bulk) {
              <div class="flex align-items-center mb-2">
                <strong class="text-sm mb-0 mr-2 -mt-1 cursor-pointer">{{'SEND_SMS.IS_CAMPAIGNS' | translate }}</strong>
                <p-toggleSwitch formControlName="is_visible" />
              </div>
            }
            <div class="surface-0 shadow-3 border-round relative text-sm">
              <!-- Campaign Fields Section -->
              @if (IsVisibleFormControl.value && smsSendType() === GetSMSSendType.Bulk) {
                <div class="p-3">
                  <!-- Form Group -->
                  <div class="mb-3">
                    <label for="campaign-name-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_SMS.CAMPAIGN_NAME' | translate }}</label>
                    <input type="text" formControlName="campaign_name" class="text-sm w-full" pInputText [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignNameFormControl.invalid && CampaignNameFormControl.touched }" />
                    @if (CampaignNameFormControl.touched && CampaignNameFormControl.invalid) {
                      <app-error-msg [errors]="CampaignNameFormControl.errors" [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate" />
                    }
                  </div>
                  <!-- Form Group -->
                  
                  <!-- Form Group -->
                  <div class="mb-3">
                    <label for="campaign-description-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_SMS.CONTENT' | translate }}</label>
                    <textarea pInputTextarea formControlName="campaign_description" class="text-sm w-full h-4rem" [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignDescriptionFormControl.invalid && CampaignDescriptionFormControl.touched }"></textarea>
                    @if (CampaignDescriptionFormControl.touched && CampaignDescriptionFormControl.invalid) {
                      <app-error-msg [errors]="CampaignDescriptionFormControl.errors" [fieldLabel]=" 'SEND_EMAIL.CONTENT' | translate" />
                    }
                  </div>
                  <!-- Form Group -->
                  
                  <!-- Form Group -->
                  <div class="mb-0">
                    <label for="campaign-schedule-date-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_SMS.SCHEDULE_DATE_ERROR' | translate }}</label>
                    <p-datepicker [showIcon]="true"
                      formControlName="campaign_action_date"
                      icon="fa fa-calendar font-light"
                      dateFormat="M dd,yy"
                      [yearNavigator]="true"
                      yearRange="2023:2030"
                      [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
                      inputStyleClass="text-sm"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignActionDateFormControl.invalid && CampaignActionDateFormControl.touched }"
                     />
                    @if (CampaignActionDateFormControl.touched && CampaignActionDateFormControl.invalid) {
                      <app-error-msg [errors]="CampaignActionDateFormControl.errors" [fieldLabel]=" 'SEND_EMAIL.SCHEDULE_DATE' | translate" />
                    }
                  </div>
                  <!-- Form Group -->
                </div>
              }
              
              <!-- Content Label -->
              @if (showCampaign.value && smsSendType() === GetSMSSendType.Bulk) {
                <div class="px-3 pt-3 pb-2">
                  <label for="content-input" class="font-medium text-700 text-xs mb-0 block uppercase">{{'SEND_SMS.CONTENT' | translate }}</label>
                </div>
              }
              
              <!-- Content Section -->
              <div class="surface-0 shadow-3 p-3 border-round text-sm">
                <div class="py-1">
                  <!-- From -->
                  <div class="pl-6 relative mb-2">
                    <span class="absolute left-0 top-0 mt-2">{{'SEND_SMS.FROM' | translate }}</span>
                    <p-select [options]="smsFrom.value" formControlName="sms_from" optionLabel="from_number" filterBy="from_number" optionDisabled="isCorporate"
                      styleClass="text-sm text-black-alpha-90 w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': SelectedSmsFromFormControl.invalid && SelectedSmsFromFormControl.touched }">
                      <ng-template pTemplate="selectedItem">
                        @if (SelectedSmsFromFormControl.value) {
                          <strong class="text-sm">{{ SelectedSmsFromFormControl.value.from_number }}</strong>
                        }
                      </ng-template>
                      <ng-template let-smsFrom pTemplate="item">
                        <div class="text-sm">{{ smsFrom.from_number }} {{smsFrom.isCorporate ? '(Corporate)' : ''}}</div>
                      </ng-template>
                    </p-select>
                  </div>
                  <!-- From -->
                  <!-- To -->
                  @if (smsSendType() !== GetSMSSendType.Campaign && smsSendType() !== GetSMSSendType.Automation) {
                    <div class="pl-6 relative mb-2">
                      <span class="absolute left-0 top-0 mt-3">{{'SEND_SMS.TO' | translate }}</span>
                      <div class="flex flex-wrap align-items-center -ml-2">
                        @for (mobileNumber of getClientMobileNos() | slice:0:4; track mobileNumber) {
                          <strong class="bg-primary border-round p-2 m-2 text-center w-full md:w-auto block">
                            {{ mobileNumber }}
                          </strong>
                        }
                        @if (getClientMobileNos().length > 4 && smsSendType() === GetSMSSendType.Bulk) {
                          <div
                            class="text-primary  ml-3 mt-2 font-bold"
                            [innerHTML]="'SEND_EMAIL.TOTAL_RECORDS' | translate : { count : selectedAllData().value ? totalRecords().value : getClientMobileNos().length }"
                          ></div>
                        }
                      </div>
                    </div>
                  }
                  <!-- To -->
                  <!-- Message -->
                  <div class="w-full relative">
                    <!-- <p-editor formControlName="body" [style]="{'height':'160px'}" [readonly]="bodyreadOnly" (ngModelChange)="Updatevalue($event)"
                  [ngClass]="{ 'ng-invalid ng-dirty': BodyFormControl.invalid && BodyFormControl.touched }"></p-editor> -->
                  <textarea pInputTextarea class="text-sm w-full h-7rem" [disabled]="true"  formControlName="body" placeholder="The maximum limit for text is 300 characters..."
                    [ngClass]="{ 'ng-invalid ng-dirty': BodyFormControl.invalid && BodyFormControl.touched }">
                  </textarea>
                  @if (BodyFormControl.touched && BodyFormControl.invalid) {
                    <app-error-msg [errors]="BodyFormControl.errors" [fieldLabel]="'SEND_EMAIL.CONTENT_LABEL' | translate" />
                  }
                </div>
                <!-- Message -->
              </div>
              <!-- Options -->
              <div class="surface-200 mt-2 text-center md:text-left py-1 md:px-3 px-0 md:flex align-items-center">
                <p-select
                  [options]="smsTemplateMasters$.value"
                  formControlName="sms_template"
                  dropdownIcon="fa fa-chevron-down"
                  optionLabel="name_primary_language"
                  filterBy="name_primary_language"
                  appendTo="body"
                  styleClass="border-none surface-200 text-primary text-sm font-bold ml-2"
                  appendTo="body"
                  [placeholder]="'SEND_EMAIL.CHOOSE_TEMPLATE' | translate"
                  [emptyMessage]="smsSendType() === GetSMSSendType.Automation ? ('SEND_EMAIL.NO_TEPLATE_FOR_EVENT' | translate : { event_type: automationMaster().value.friendly_name }) : ('SEND_EMAIL.NO_TEMPLATE_FOUND' | translate)"
                  (onChange)="SelectSmsTemplate()"
                  >
                  <ng-template pTemplate="selectedItem">
                    @if (SelectedSmsTemplateFormControl.value) {
                      <strong class="text-sm text-primary">{{ SelectedSmsTemplateFormControl.value.name_primary_language }}</strong>
                    }
                  </ng-template>
                  <ng-template let-template pTemplate="item">
                    <div class="text-sm">{{ template.name_primary_language }}</div>
                  </ng-template>
                </p-select>
              </div>
              <!-- Options -->
              <!-- <div class="flex align-items-center p-3" *ngIf="emailSendType == GetEmailSendType.FreeForm">
              <p-toggleSwitch ></p-toggleSwitch>
              <label class="ml-3 -mt-1 flex align-items-center">
                {{'SEND_EMAIL.NOT_MARKETING_MSG' | translate }} <i class="fa fa-circle-question text-base text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
              </label>
            </div> -->
            </div>
          </div>
        </div>
        <!-- Content -->
        <!-- Modal Footer -->
        <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
          <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" (click)="closePopupUp()" />
          @if (smsSendType() !== GetSMSSendType.Campaign && smsSendType() !== GetSMSSendType.Automation) {
            <p-button [label]="'SEND_SMS.SEND_SMS' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SendSms()" />
          }
          @if (smsSendType() === GetSMSSendType.Campaign || smsSendType() === GetSMSSendType.Automation) {
            <p-button [label]="'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SaveData()" />
          }
        </div>
      </div>
    }
  </form>
</ng-template>
</p-dialog>
<!-- Send Bulk SMS Modal -->
